import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { Loader } from "@mantine/core";

import { useSession } from "@prostocheck/data-web";

export interface IRequireSessionProps {
  children: ReactNode;
}

/**
 * `isRestoringSession` covers the one gap a persisted session leaves:
 * restoring it is async (it replays a real `Objects` call), while this
 * renders synchronously on every reload. Redirecting before that settles
 * would bounce an already signed-in user to `/login` and strand them there.
 * See ai/docs/kep-signing.md.
 */
export const RequireSession = ({ children }: IRequireSessionProps) => {
  const { session, isRestoringSession } = useSession();

  if (isRestoringSession) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (!session) return <Navigate to="/login" replace />;

  return <>{children}</>;
};
